module.exports = __webpack_public_path__ + "static/media/ticket-uber-2.3a0c86cd.gif";